import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { CompetencyDto } from '../../competencies/response/competency.dto'

/**
 * DTO de réponse pour un Concept
 * Basé sur le modèle Prisma Concept du curriculum-service
 */
export class ConceptDto {
  @ApiProperty({ description: 'Identifiant unique du concept' })
  id?: string

  @ApiPropertyOptional({ description: 'Code du concept' })
  code?: string | null

  @ApiProperty({ description: 'Libellé du concept' })
  label?: string

  @ApiPropertyOptional({ description: 'Description du concept', type: 'string' })
  description?: string | null

  @ApiProperty({ description: 'Synonymes du concept', type: [String] })
  synonyms?: string[]

  @ApiProperty({ description: 'Slug unique du concept' })
  slug?: string

  @ApiPropertyOptional({ description: 'Identifiant de la matière associée' })
  subjectId?: string | null

  @ApiProperty({ description: 'Indique si le concept est archivé' })
  isArchived?: boolean

  @ApiProperty({ description: 'Date de création' })
  createdAt?: Date | string

  @ApiProperty({ description: 'Date de mise à jour' })
  updatedAt?: Date | string

  @ApiPropertyOptional({ description: 'Date de suppression' })
  deletedAt?: Date | string | null
  
  @ApiPropertyOptional({
    description: 'Compétences associées à la notion dans le programme',
    type: () => [CompetencyDto],
  })
  competencies?: CompetencyDto[]
}
